module.exports = __webpack_public_path__ + "img/generated-1772421187292.fde236eb.png";